export default __webpack_public_path__ + "static/media/logow.cfdb6b2d.svg";